// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__8-0kb","countSelected":"ManageSelection_countSelected__ylhfT"};